module.exports = __webpack_public_path__ + "img/avatar3.97e4bfbf.png";